import { applyStyle } from '../css';
const STATUS_COLOR = {
    online: 'var(--status-online)',
    offline: 'var(--status-offline)',
    busy: 'var(--status-busy)',
    error: 'var(--status-error)',
    info: 'var(--status-info)',
    success: 'var(--accent)',
};
/** Sol tarafta yuvarlak nokta + metin. Status renkli dot. */
export function createStatusBadge(status, label) {
    const wrap = document.createElement('span');
    applyStyle(wrap, {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 'var(--sp-2)',
        fontSize: 'var(--fs-caption)',
        color: 'var(--text-secondary)',
        fontWeight: '500',
    });
    const dot = document.createElement('span');
    applyStyle(dot, {
        width: '8px',
        height: '8px',
        borderRadius: 'var(--radius-pill)',
        background: STATUS_COLOR[status],
        flexShrink: '0',
        boxShadow: status === 'online' || status === 'success'
            ? `0 0 0 3px ${STATUS_COLOR[status]}33`
            : 'none',
    });
    const text = document.createElement('span');
    text.textContent = label;
    wrap.append(dot, text);
    return wrap;
}
/** Etiket badge — küçük renkli kapsül. AKTİF/TAMAM/HATA/BİTTİ vb. */
export function createTagBadge(label, tone = 'default') {
    const span = document.createElement('span');
    span.textContent = label.toUpperCase();
    let bg = 'var(--bg-elev-3)';
    let color = 'var(--text-secondary)';
    let border = '1px solid var(--border-subtle)';
    if (tone === 'accent') {
        bg = 'var(--accent-soft)';
        color = 'var(--accent)';
        border = '1px solid var(--accent)';
    }
    else if (tone === 'mono') {
        bg = 'var(--bg-elev-3)';
        color = 'var(--text-primary)';
    }
    else if (tone in STATUS_COLOR) {
        const c = STATUS_COLOR[tone];
        bg = `${c}1a`;
        color = c;
        border = `1px solid ${c}55`;
    }
    applyStyle(span, {
        display: 'inline-block',
        padding: '3px 10px',
        fontSize: 'var(--fs-tiny)',
        fontWeight: '600',
        letterSpacing: '0.06em',
        background: bg,
        color: color,
        border: border,
        borderRadius: 'var(--radius-pill)',
        whiteSpace: 'nowrap',
    });
    return span;
}
/** Bağlantı kalitesi rozeti — topbar için "BAĞLI · 28 ms" */
export function createConnectionBadge(opts) {
    const wrap = document.createElement('div');
    const color = opts.connected ? 'var(--accent)' : 'var(--status-offline)';
    applyStyle(wrap, {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 'var(--sp-2)',
        padding: '6px 14px',
        fontSize: 'var(--fs-caption)',
        fontWeight: '600',
        letterSpacing: '0.08em',
        color: color,
        background: opts.connected ? 'var(--accent-soft)' : 'var(--bg-elev-3)',
        border: `1px solid ${opts.connected ? 'var(--accent)' : 'var(--border-strong)'}`,
        borderRadius: 'var(--radius-pill)',
        whiteSpace: 'nowrap',
    });
    const dot = document.createElement('span');
    applyStyle(dot, {
        width: '8px',
        height: '8px',
        borderRadius: 'var(--radius-pill)',
        background: color,
        boxShadow: opts.connected ? `0 0 0 3px ${color}33` : 'none',
    });
    wrap.append(dot);
    const text = document.createElement('span');
    const mainLabel = opts.label ?? (opts.connected ? 'BAĞLI' : 'ÇEVRİMDIŞI');
    text.textContent = opts.latencyMs !== undefined && opts.connected
        ? `${mainLabel} · ${opts.latencyMs} MS`
        : mainLabel;
    wrap.append(text);
    return wrap;
}
